import React, { useEffect, useState } from 'react'
import { formatTokenAmount } from './formatAmount'

const shortAddress = (value) => value ? `${value.slice(0, 6)}...${value.slice(-4)}` : '-'

export default function DataTable({ title, rows = [], total = 0, perPage = 10, stakeDecimals, rewardDecimals, onPageChange, onCopy, t }) {
    const [page, setPage] = useState(1)
    const totalPages = Math.max(1, Math.ceil(Number(total || 0) / Number(perPage || 10)))

    useEffect(() => {
        setPage((current) => Math.min(current, totalPages))
    }, [totalPages])

    const move = (nextPage) => {
        const resolved = Math.min(Math.max(nextPage, 1), totalPages)
        if (resolved === page) return
        setPage(resolved)
        onPageChange?.(resolved)
    }

    return (
        <section className="console-data-table" aria-label={title}>
            <div className="console-data-table__heading"><div><span className="console-eyebrow">{title}</span><strong>{Number(total || 0)}</strong></div></div>
            <div className="console-table-scroll">
                <table className="console-user-table">
                    <colgroup>
                        <col className="console-user-table__address" />
                        <col className="console-user-table__amount" />
                        <col className="console-user-table__amount" />
                        <col className="console-user-table__claimed" />
                        <col className="console-user-table__address" />
                    </colgroup>
                    <thead><tr><th>{t('地址')}</th><th>{t('已质押')}</th><th>{t('总奖励')}</th><th>{t('已领取奖励')}</th><th>{t('邀请人')}</th></tr></thead>
                    <tbody>
                        {rows.length > 0 ? rows.map((row, index) => <tr key={`${row.userAddr || 'user'}-${index}`}>
                            <td><button type="button" className="console-copy-value" onClick={() => onCopy?.(row.userAddr)} title={row.userAddr}>{shortAddress(row.userAddr)} <i className="fa fa-copy" /></button></td>
                            <td>{formatTokenAmount(row.stakedTokenAmount, stakeDecimals)}</td>
                            <td>{formatTokenAmount(row.rewardTokenAmount, rewardDecimals)}</td>
                            <td>{formatTokenAmount(row.claimedTokenAmount, rewardDecimals)}</td>
                            <td>{row.invitor && /^0x0{40}$/i.test(row.invitor) === false ? <button type="button" className="console-copy-value" onClick={() => onCopy?.(row.invitor)} title={row.invitor}>{shortAddress(row.invitor)} <i className="fa fa-copy" /></button> : '-'}</td>
                        </tr>) : <tr><td colSpan="5" className="console-table-empty">{t('暂无数据')}</td></tr>}
                    </tbody>
                </table>
            </div>
            {totalPages > 1 && <nav className="console-pagination" aria-label={title}>
                <button type="button" onClick={() => move(page - 1)} disabled={page === 1} aria-label={`${t('上一页')} ${title}`}><i className="fa fa-chevron-left" /></button>
                <span>{page} / {totalPages}</span>
                <button type="button" onClick={() => move(page + 1)} disabled={page === totalPages} aria-label={`${t('下一页')} ${title}`}><i className="fa fa-chevron-right" /></button>
            </nav>}
        </section>
    )
}
